import { makeActonCreator } from '../util';

export const UPDATE_COMMENT_COUNT = 'UPDATE_COMMENT_COUNT';
export const UPDATE_CURRENT_PROJECT = 'UPDATE_CURRENT_PROJECT';

export const updateCommentCount = makeActonCreator(UPDATE_COMMENT_COUNT);
export const updateCurrentProject = makeActonCreator(UPDATE_CURRENT_PROJECT);
